import React from 'react';
import styled from 'styled-components/macro';

import Element from '@mirinae/lessons/components/lesson/elements/Element';
import { colorMap } from '@mirinae/lessons/modules/defines/styles';

import leftArrow from '@mirinae/lessons/assets/images/leftArrow.png';
import rightArrow from '@mirinae/lessons/assets/images/rightArrow.png';

const PhraseWrapper = styled.div`
    display: flex;
    flex-direction: row;
`;

const WordWrapper = styled.div`
    position: relative;
`;

const Word = styled.span`
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 50px;
    margin: 0 2px 0 2px;
    color: ${props => colorMap[props.part.color]};
    border-bottom: ${props => (props.part.annotation ? 'solid black 4px' : 'none')}; 
`;

const Annotation = styled.div`
    position: absolute;
    top: 100px;
    ${(props) => (props.pos === 'left' ? 'right: 30px;' : 'left: 30px;')};
    font-size: 24px;
    font-weight: 500;
    width: fit-content;
`;

const Arrow = styled.img`
    position: absolute;
    top: 64px;
    left: ${props => (props.pos === 'left' ? -15 : 20)}px;);
    content: url(${props => (props.pos === 'left' ? leftArrow : rightArrow)});
`;

const PhraseWord = ({ part, element }) => {

    const pos = () => (part.annotation[0] === '<' ? 'left' : 'right');

    return (
        <WordWrapper>
            <Word part={part} element={element}>{ part.value }</Word>
            { part.annotation && (
                <>
                    <Arrow part={part} pos={pos()} />
                    <Annotation part={part} pos={pos()}>{part.annotation.replace(/[<>]/, '')}</Annotation>
                </>
            )}
        </WordWrapper>
    );
};

const PhraseWithArrow = ({ element }) => {
    return (
        <Element element={element}>
            <PhraseWrapper>
                { element.fieldsByName.phrase.parts.koreanParts.map((part, i) => <PhraseWord key={i} part={part} element={element} />)}
            </PhraseWrapper>
        </Element>
    );
};

export default PhraseWithArrow;
